import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocalizeMessage } from 'libs.nucleus';
import { ConfigurationDefinitionList } from './configuration_definition_list.component';
import { displayLanguage, formatConfigurationTimestamp, } from './consent_template_configuration.helpers';
const emptyValue = (translate, value) => value && value.length > 0 ? value : translate('(No items.)');
export const TemplateDetailsSection = ({ document, version, source, actors, }) => {
    const translate = useLocalizeMessage();
    const fileName = source.sourceFileName || document.name;
    const pageCount = document.totalPages > 0 ? translate('{count} pages', { count: String(document.totalPages) }) : undefined;
    const customDataValue = document.customFields.length === 0
        ? translate('(No items.)')
        : document.customFields.map((field) => `${field.ec__label}: ${field.ec__value}`).join(', ');
    return (_jsxs("div", { className: 'nucleus-flex nucleus-flex-col nucleus-gap-8 nucleus-px-6 nucleus-py-6', "data-testid": 'template-details-section', children: [_jsx(ConfigurationDefinitionList, { title: translate('Template details'), rows: [
                    {
                        label: translate('Template'),
                        value: pageCount ? `${fileName}  ·  ${pageCount}` : fileName,
                        testId: 'configuration-template-file',
                    },
                    { label: translate('Version'), value: `v${version}`, testId: 'configuration-version' },
                    { label: translate('Template title'), value: document.name, testId: 'configuration-title' },
                    {
                        label: translate('Language'),
                        value: emptyValue(translate, displayLanguage(document.language)),
                        testId: 'configuration-language',
                    },
                    {
                        label: translate('Description'),
                        value: emptyValue(translate, document.description),
                        testId: 'configuration-description',
                    },
                    {
                        label: translate('Created By'),
                        value: emptyValue(translate, actors.createdBy),
                        testId: 'configuration-created-by',
                    },
                    {
                        label: translate('Created On'),
                        value: emptyValue(translate, formatConfigurationTimestamp(document.createdAt)),
                        testId: 'configuration-created-on',
                    },
                    {
                        label: translate('Updated By'),
                        value: emptyValue(translate, actors.updatedBy),
                        testId: 'configuration-updated-by',
                    },
                    {
                        label: translate('Updated On'),
                        value: emptyValue(translate, formatConfigurationTimestamp(document.updatedAt)),
                        testId: 'configuration-updated-on',
                    },
                ] }), _jsx(ConfigurationDefinitionList, { title: translate('Source document'), rows: [
                    {
                        label: translate('Source label'),
                        value: emptyValue(translate, source.sourceLabel),
                        testId: 'configuration-source-label',
                    },
                    {
                        label: translate('Version date'),
                        value: emptyValue(translate, source.sourceVersionDate),
                        testId: 'configuration-source-version-date',
                    },
                    {
                        label: translate('Source version'),
                        value: emptyValue(translate, source.sourceVersion),
                        testId: 'configuration-source-version',
                    },
                ] }), _jsx(ConfigurationDefinitionList, { title: translate('Custom fields'), rows: [
                    {
                        label: translate('Custom data'),
                        value: customDataValue,
                        testId: 'configuration-custom-data',
                    },
                ] })] }));
};
